import React, { useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteEvent,
  detailEvent,
  listEvents,
} from "../redux/actions/eventsAction";
import moment from "moment";
import { Link } from "react-router-dom";

const EventsScreen = () => {
  const listEventsState = useSelector((state) => state.listEvents);
  const { events } = listEventsState;
  const eventDeleteState = useSelector((state) => state.eventDelete);
  const { success } = eventDeleteState;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(listEvents());
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Events" button="Add Event" link="/add-event" />
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-3">List of Events</h4>
          {/* <p class="card-title-desc">
            Add <code>.table-bordered</code> for borders on all sides of the
            table and cells.
          </p> */}

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Venue</th>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Created At</th>
                  <th>Description</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {events &&
                  events.map((value) => (
                    <tr>
                      <th scope="row">{value.venue}</th>
                      <td>{value.title}</td>

                      <td>{moment(value.date).format("MMMM Do YYYY")}</td>

                      <td>{moment(value.createdAt).format("MMMM Do YYYY")}</td>

                      <td style={{ width: "500px" }}>{value.description}</td>
                      <td style={{ width: "100px" }}>
                        <Link
                          to={`/edit-event/${value.uuid}`}
                          onClick={() => dispatch(detailEvent(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </Link>
                        <button
                          style={{
                            marginLeft: "5px",
                            backgroundColor: "red",
                            color: "#fff",
                          }}
                          to={`/edit-honorory/${value.uuid}`}
                          onClick={() => dispatch(deleteEvent(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default EventsScreen;
